import { render, staticRenderFns } from "./WidgetSlotContainer.vue?vue&type=template&id=5e7bc1e7&scoped=true&"
import script from "./WidgetSlotContainer.vue?vue&type=script&lang=js&"
export * from "./WidgetSlotContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7bc1e7",
  null
  
)

export default component.exports